// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  color: white;
  background: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  padding-inline: 25px;
}

.back-button {
  height: 16px;
}

.brand-logo {
  height: 26px;
}

.menu-wrapper {
  height: 16px;
  width: 32px;
}

.brand-desc {
  margin: 0px;
  margin-top: 5px;
  color: var(--ion-color-black);
  text-align: center;
  font-size: 14px;
  line-height: 17px;
}

app-burger-btn {
  position: absolute;
  right: 0;
  top: 0;
}

ion-footer {
  width: auto;
}
ion-footer ion-button {
  font-size: 18px;
}

ion-footer {
  padding: 5px 16px 9px;
}
ion-footer .footer-info {
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  color: #000;
  padding-top: 8px;
  margin-bottom: 8px;
}
ion-footer .social {
  margin: 0 auto 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
}
ion-footer .social .social-item {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}
ion-footer .social .social-item:last-child {
  margin-right: 0;
}
ion-footer .social .social-item .social-icon {
  height: 100%;
}
ion-footer ion-button {
  margin-top: 9px;
}
@media (min-width: 991px) {
  ion-footer {
    width: 50%;
    align-self: center;
    box-shadow: none !important;
  }
  ion-footer .social,
  ion-footer .footer-info,
  ion-footer .separator {
    display: none;
  }
}

ion-card {
  margin: 3px 0;
  border: 1px solid #ececec;
  border-radius: 0px;
  box-shadow: none;
  word-break: break-word;
  --color: black;
  --preorder-type-chip-border-color: var(--ion-color-primary);
}
ion-card ion-card-content {
  padding: 10px;
  line-break: auto !important;
}
ion-card ion-card-content:first-of-type {
  border: none;
}

app-preorder-type-chip {
  --preorder-type-chip-border-color: var(--ion-color-dark);
  --preorder-type-chip-background: var(--ion-color-dark) !important;
  --preorder-type-chip-color: var(--ion-color-primary);
}

ion-chip {
  margin: 0;
  margin-left: auto;
  background: var(--ion-color-primary);
  padding: 2px 10px;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: unset;
  width: -moz-fit-content;
  width: fit-content;
}
ion-chip ion-label {
  font-family: AppFontBold;
  font-size: 9px;
  line-height: 10px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
}

.after-first-card {
  margin: 12px 0 -8px;
}

.your-order-title {
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  font-weight: bold;
}

.header-wrap {
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px !important;
  font-family: AppFontBold, sans-serif;
}

.price-title {
  font-size: 16px;
  font-weight: 700;
}

.ticket-number {
  text-align: center;
  margin-bottom: 12px;
}

ion-footer ion-button {
  font-size: 16px;
}

ion-col b,
ion-col h3,
ion-col ion-card-title {
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-black);
  text-transform: uppercase;
}

.hint_text {
  padding: 0px 11px;
  margin: 10px 0px;
  font-family: AppFont;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  color: #ffffff;
}

.price {
  font-family: SecondFont, sans-serif !important;
}

.left-col {
  font-family: AppFontBold;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  color: #000;
}

.right-col {
  font-family: AppFont;
  font-size: 10px;
  line-height: 15px;
  text-align: right;
  color: #1a1a18;
}

.option-name,
.option-price {
  font-family: AppFontBold;
  font-size: 9px;
  line-height: 10px;
  text-align: left;
  color: #808080;
}

.price-col {
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 15px;
  text-align: right;
  color: #000;
}

.total_price,
.price-title {
  font-family: AppFontBold;
  font-size: 15px;
  line-height: 15px;
  text-align: left;
  color: #000;
}

.option-price,
.total_price {
  text-align: right;
}

.points {
  background-color: #fff;
  box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.0588235294);
  padding: 9px 18px;
  width: 100%;
  margin-bottom: 12px;
}
.points_info {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 12px;
}
.points_info ion-img {
  width: 62px;
  height: 20px;
}
.points .img-info {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  text-align: left;
  color: #000000;
  text-transform: capitalize;
}
.points_text {
  display: flex;
  flex-direction: column;
  width: 54%;
}
.points_title {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 15px;
  text-align: left;
  color: #000000;
}
.points_description {
  font-family: AppFont;
  font-size: 9px;
  line-height: 10px;
  text-align: left;
  color: #000000;
}
.points_current {
  height: 40px;
  width: 40px;
  background: url('doted_circle.png') no-repeat center center/100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.points_quantity {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #000;
}
.points .buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  margin-bottom: 20px;
}
.points .buttons_button {
  width: 100%;
  height: 36px;
  background-color: var(--ion-color-primary);
  color: #fff;
  border: 1.5px solid var(--ion-color-primary);
  border-radius: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  text-transform: uppercase;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  height: 8px;
  background-image: url('dot.svg');
  background-size: 7px 100%;
}

.delivery-options:has(.status-show) .header-sliders {
  position: relative;
  bottom: 15px;
  z-index: 2;
}

.header-sliders {
  display: flex;
  justify-content: space-between;
}
.header-sliders .step {
  width: 32%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.header-sliders .step .line {
  width: 100%;
  height: 10px;
  background-color: #d9d9d9;
  margin-bottom: 5px;
}
.header-sliders .step .line.selected {
  background-color: #10843e;
  animation: pulse 2s infinite;
}
.header-sliders .step p {
  font-family: AppFont;
  font-size: 12px;
  line-height: 14.51px;
  vertical-align: middle;
  color: #1a1a18;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}
.queue {
  width: 17px;
  height: 17px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #db052c;
  border-radius: 50px;
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 15.41px;
  text-align: center;
  vertical-align: middle;
  color: #1a1a18 !important;
}

.delivery-steps {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.delivery-steps__item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.delivery-steps__item ion-icon {
  width: 100px;
  height: 100px;
  margin-bottom: 25px;
}
.delivery-steps .map-block {
  min-height: 0px;
  opacity: 0;
  z-index: -1;
  max-height: 0px;
}
.delivery-steps .map-block .show-time {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 30px;
  padding: 10px 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  font-family: AppFont;
  font-size: 14px;
  text-align: center;
  color: var(--ion-color-black) !important;
}
.delivery-steps .map-block .show-time span {
  font-family: AppFontBold;
  font-size: 22px;
  text-align: center;
  color: var(--ion-color-black) !important;
}
.delivery-steps .map-block .status-show {
  width: 85%;
  position: absolute;
  left: 50%;
  bottom: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 10px 20px;
  transform: translateX(-50%);
  border-radius: 3px;
  z-index: 999;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: var(--ion-color-black) !important;
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
}
.delivery-steps .map-block.hide-item {
  min-height: 400px;
  max-height: 400px;
  opacity: 1;
  z-index: 1;
}

.header-title {
  font-family: AppFontBold;
  font-size: 22px;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 16px;
  color: #fff !important;
}

.estimation-text {
  font-family: AppFont;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: var(--ion-color-black) !important;
}

.estimation-time {
  font-family: AppFontBold;
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
  text-align: center;
  color: var(--ion-color-black) !important;
  margin-bottom: 17px;
}

.delivery-info {
  width: 280px;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 1.15em;
  letter-spacing: 2%;
  text-align: center;
  vertical-align: bottom;
  text-transform: uppercase;
  color: var(--ion-color-black);
  margin-bottom: 17px;
}

.delivery-options {
  position: relative;
  background-color: #fff;
  padding: 20px 15px;
  margin-bottom: 20px;
}

.map-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.map-frame {
  border: 2px solid black;
  height: 100%;
}

#map-item {
  height: 100%;
}

.bigger-img {
  min-width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AADD;;AAIA;EACC,YAAA;AADD;;AAQA;EACC,YAAA;AALD;;AAQA;EACC,YAAA;EACA,WAAA;AALD;;AAQA;EACC,WAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AALD;;AAQA;EACC,kBAAA;EACA,QAAA;EACA,MAAA;AALD;;AAQA;EAEC,WAAA;AAND;AAOC;EACC,eAAA;AALF;;AASA;EACC,qBAAA;AAND;AAOC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AANF;AAQC;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;AANF;AAQE;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AANH;AAOG;EACC,eAAA;AALJ;AAQG;EACC,YAAA;AANJ;AAWC;EACC,eAAA;AATF;AC5EE;EDmDF;IAsCE,UAAA;IACA,kBAAA;IACA,2BAAA;EATA;EAWA;;;IAGC,aAAA;EATD;AACF;;AAaA;EACC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,2DAAA;AAVD;AAYC;EACC,aAAA;EACA,2BAAA;AAVF;AAYE;EACC,YAAA;AAVH;;AAcA;EACC,wDAAA;EACA,iEAAA;EACA,oDAAA;AAXD;;AAaA;EACC,SAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;AAVD;AAYC;EACC,wBAAA;EACA,cAAA;EACA,iBAAA;EAEA,kBAAA;EACA,yBAAA;EACA,WAAA;AAXF;;AAeA;EACC,mBAAA;AAZD;;AAeA;EACC,yBAAA;EACA,iCAAA;EACA,iBAAA;AAZD;;AAcA;EACC,aAAA;EACA,mBAAA;AAXD;;AAaA;EACC,0BAAA;EACA,oCAAA;AAVD;;AAYA;EACC,eAAA;EACA,gBAAA;AATD;;AAWA;EACC,kBAAA;EACA,mBAAA;AARD;;AAWC;EACC,eAAA;AARF;;AAYC;;;EAGC,oCAAA;EACA,6BAAA;EACA,yBAAA;AATF;;AAYA;EACC,iBAAA;EACA,gBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,cAAA;AAXD;;AAcA;EACC,8CAAA;AAXD;;AAcA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAZD;;AAeA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,cAAA;AAbD;;AAgBA;;EAEC,wBAAA;EACA,cAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;AAdD;;AAiBA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,WAAA;AAfD;;AAkBA;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAhBD;;AAmBA;;EAEC,iBAAA;AAhBD;;AAmBA;EACC,sBAAA;EACA,wDAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAhBD;AAkBC;EACC,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,mBAAA;AAhBF;AAkBE;EACC,WAAA;EACA,YAAA;AAhBH;AAoBC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;EACA,0BAAA;AAnBF;AAsBC;EACC,aAAA;EACA,sBAAA;EACA,UAAA;AApBF;AAuBC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;AAtBF;AAyBC;EACC,oBAAA;EACA,cAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;AAxBF;AA2BC;EACC,YAAA;EACA,WAAA;EACA,gEAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AA1BF;AA6BC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AA3BF;AA8BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EAEA,mBAAA;AA7BF;AA+BE;EACC,WAAA;EACA,YAAA;EAEA,0CAAA;EACA,WAAA;EACA,4CAAA;EACA,mBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,yBAAA;AAjCH;;AAsCA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAnCD;AAqCC;EACC,WAAA;EACA,gCAAA;EACA,yBAAA;AAnCF;;AA2CC;EACC,kBAAA;EACA,YAAA;EACA,UAAA;AAxCF;;AA4CA;EACC,aAAA;EACA,8BAAA;AAzCD;AA4CC;EACC,UAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AA1CF;AA2CE;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAzCH;AA0CG;EACC,yBAAA;EAEA,4BAAA;AAzCJ;AA4CE;EACC,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;AA1CH;;AA8CA;EACC;IAEC,UAAA;EA5CA;EA8CD;IACC,YAAA;EA5CA;AACF;AA8CA;EACC,WAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AA7CD;;AA+CA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AA5CD;AA6CC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA3CF;AA6CE;EACC,YAAA;EACA,aAAA;EACA,mBAAA;AA3CH;AA8CC;EACC,eAAA;EAEA,UAAA;EACA,WAAA;EACA,eAAA;AA7CF;AA+CE;EACC,aAAA;EACA,sBAAA;EAEA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EAEA,kBAAA;EAEA,wCAAA;AAhDH;AAkDG;EACC,wBAAA;EACA,eAAA;EAEA,kBAAA;EACA,wCAAA;AAjDJ;AAqDE;EACC,UAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EAEA,yBAAA;EACA,wCAAA;EACA,wDAAA;AAtDH;AAwDE;EACC,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;AAtDH;;AA2DA;EACC,wBAAA;EACA,eAAA;EAEA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AAzDD;;AA4DA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,wCAAA;AA1DD;;AA4DA;EACC,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EAEA,wCAAA;EACA,mBAAA;AA3DD;;AA8DA;EACC,YAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AA3DD;;AA8DA;EACC,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AA3DD;;AA8DA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AA3DD;;AA8DA;EACC,uBAAA;EACA,YAAA;AA3DD;;AA8DA;EACC,YAAA;AA3DD;;AA8DA;EACC,gBAAA;AA3DD","sourcesContent":["@import '../../../theme/mixins';\n\nion-header {\n\tcolor: white;\n\tbackground: transparent;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\theight: 52px;\n\tpadding-inline: 25px;\n}\n\n.back-button {\n\theight: 16px;\n}\n\nion-content {\n\t// height: 75vh;\n}\n\n.brand-logo {\n\theight: 26px;\n}\n\n.menu-wrapper {\n\theight: 16px;\n\twidth: 32px;\n}\n\n.brand-desc {\n\tmargin: 0px;\n\tmargin-top: 5px;\n\tcolor: var(--ion-color-black);\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 17px;\n}\n\napp-burger-btn {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n}\n\nion-footer {\n\t// height: 12vh;\n\twidth: auto;\n\tion-button {\n\t\tfont-size: 18px;\n\t}\n}\n\nion-footer {\n\tpadding: 5px 16px 9px;\n\t.footer-info {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 10px;\n\t\tline-height: 12px;\n\n\t\ttext-align: center;\n\t\tcolor: #000;\n\t\tpadding-top: 8px;\n\t\tmargin-bottom: 8px;\n\t}\n\t.social {\n\t\tmargin: 0 auto 9px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: fit-content;\n\n\t\t.social-item {\n\t\t\twidth: 22px;\n\t\t\theight: 22px;\n\t\t\tmargin-right: 10px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\n\t\t\t.social-icon {\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\t}\n\n\tion-button {\n\t\tmargin-top: 9px;\n\t}\n\n\t@include desktop {\n\t\twidth: 50%;\n\t\talign-self: center;\n\t\tbox-shadow: none !important;\n\n\t\t.social,\n\t\t.footer-info,\n\t\t.separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\nion-card {\n\tmargin: 3px 0;\n\tborder: 1px solid #ececec;\n\tborder-radius: 0px;\n\tbox-shadow: none;\n\tword-break: break-word;\n\t--color: black;\n\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\n\tion-card-content {\n\t\tpadding: 10px;\n\t\tline-break: auto !important;\n\n\t\t&:first-of-type {\n\t\t\tborder: none;\n\t\t}\n\t}\n}\napp-preorder-type-chip {\n\t--preorder-type-chip-border-color: var(--ion-color-dark);\n\t--preorder-type-chip-background: var(--ion-color-dark) !important;\n\t--preorder-type-chip-color: var(--ion-color-primary);\n}\nion-chip {\n\tmargin: 0;\n\tmargin-left: auto;\n\tbackground: var(--ion-color-primary);\n\tpadding: 2px 10px;\n\tborder-radius: 28px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: unset;\n\twidth: fit-content;\n\n\tion-label {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 9px;\n\t\tline-height: 10px;\n\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t}\n}\n\n.after-first-card {\n\tmargin: 12px 0 -8px;\n}\n\n.your-order-title {\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-secondary);\n\tfont-weight: bold;\n}\n.header-wrap {\n\tdisplay: flex;\n\talign-items: center;\n}\n.title {\n\tfont-size: 18px !important;\n\tfont-family: AppFontBold, sans-serif;\n}\n.price-title {\n\tfont-size: 16px;\n\tfont-weight: 700;\n}\n.ticket-number {\n\ttext-align: center;\n\tmargin-bottom: 12px;\n}\nion-footer {\n\tion-button {\n\t\tfont-size: 16px;\n\t}\n}\nion-col {\n\tb,\n\th3,\n\tion-card-title {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tcolor: var(--ion-color-black);\n\t\ttext-transform: uppercase;\n\t}\n}\n.hint_text {\n\tpadding: 0px 11px;\n\tmargin: 10px 0px;\n\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 12px;\n\n\ttext-align: center;\n\tcolor: #ffffff;\n}\n\n.price {\n\tfont-family: SecondFont, sans-serif !important;\n}\n\n.left-col {\n\tfont-family: AppFontBold;\n\tfont-size: 13px;\n\tline-height: 16px;\n\n\ttext-align: left;\n\tcolor: #000;\n}\n\n.right-col {\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 15px;\n\n\ttext-align: right;\n\tcolor: #1a1a18;\n}\n\n.option-name,\n.option-price {\n\tfont-family: AppFontBold;\n\tfont-size: 9px;\n\tline-height: 10px;\n\n\ttext-align: left;\n\tcolor: #808080;\n}\n\n.price-col {\n\tfont-family: AppFontBold;\n\tfont-size: 12px;\n\tline-height: 15px;\n\n\ttext-align: right;\n\tcolor: #000;\n}\n\n.total_price,\n.price-title {\n\tfont-family: AppFontBold;\n\tfont-size: 15px;\n\tline-height: 15px;\n\n\ttext-align: left;\n\tcolor: #000;\n}\n\n.option-price,\n.total_price {\n\ttext-align: right;\n}\n\n.points {\n\tbackground-color: #fff;\n\tbox-shadow: 0px 0px 35px 0px #0000000f;\n\tpadding: 9px 18px;\n\twidth: 100%;\n\tmargin-bottom: 12px;\n\n\t&_info {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: stretch;\n\t\tmargin-bottom: 12px;\n\n\t\tion-img {\n\t\t\twidth: 62px;\n\t\t\theight: 20px;\n\t\t}\n\t}\n\n\t.img-info {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 15px;\n\n\t\ttext-align: left;\n\t\tcolor: #000000;\n\t\ttext-transform: capitalize;\n\t}\n\n\t&_text {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 54%;\n\t}\n\n\t&_title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 16px;\n\t\tline-height: 15px;\n\n\t\ttext-align: left;\n\t\tcolor: #000000;\n\t}\n\n\t&_description {\n\t\tfont-family: AppFont;\n\t\tfont-size: 9px;\n\t\tline-height: 10px;\n\n\t\ttext-align: left;\n\t\tcolor: #000000;\n\t}\n\n\t&_current {\n\t\theight: 40px;\n\t\twidth: 40px;\n\t\tbackground: url(../../../assets/losteria/doted_circle.png) no-repeat center center/ 100%;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t&_quantity {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 15px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t}\n\n\t.buttons {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tgap: 10px;\n\n\t\tmargin-bottom: 20px;\n\n\t\t&_button {\n\t\t\twidth: 100%;\n\t\t\theight: 36px;\n\n\t\t\tbackground-color: var(--ion-color-primary);\n\t\t\tcolor: #fff;\n\t\t\tborder: 1.5px solid var(--ion-color-primary);\n\t\t\tborder-radius: 41px;\n\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 17px;\n\n\t\t\ttext-align: center;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\t}\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t.line {\n\t\theight: 8px;\n\t\tbackground-image: url(../../../assets/losteria/dot.svg);\n\t\tbackground-size: 7px 100%;\n\t}\n\t// &--wide .line {\n\t// \tbackground-size: 8px 100%;\n\t// }\n}\n\n.delivery-options:has(.status-show) {\n\t.header-sliders {\n\t\tposition: relative;\n\t\tbottom: 15px;\n\t\tz-index: 2;\n\t}\n}\n\n.header-sliders {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\n\t.step {\n\t\twidth: 32%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\t.line {\n\t\t\twidth: 100%;\n\t\t\theight: 10px;\n\t\t\tbackground-color: #d9d9d9;\n\t\t\tmargin-bottom: 5px;\n\t\t\t&.selected {\n\t\t\t\tbackground-color: #10843e;\n\n\t\t\t\tanimation: pulse 2s infinite;\n\t\t\t}\n\t\t}\n\t\tp {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 14.51px;\n\t\t\tvertical-align: middle;\n\t\t\tcolor: #1a1a18;\n\t\t}\n\t}\n}\n@keyframes pulse {\n\t0%,\n\t100% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0.7;\n\t}\n}\n.queue {\n\twidth: 17px;\n\theight: 17px;\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 1px solid #db052c;\n\tborder-radius: 50px;\n\n\tfont-family: AppFontBold;\n\tfont-size: 10px;\n\tline-height: 15.41px;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcolor: #1a1a18 !important;\n}\n.delivery-steps {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\t&__item {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t// position: relative;\n\t\tion-icon {\n\t\t\twidth: 100px;\n\t\t\theight: 100px;\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\t}\n\t.map-block {\n\t\tmin-height: 0px;\n\n\t\topacity: 0;\n\t\tz-index: -1;\n\t\tmax-height: 0px;\n\t\t// position: relative;\n\t\t.show-time {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\n\t\t\tposition: absolute;\n\t\t\ttop: 30px;\n\t\t\tpadding: 10px 20px;\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t\tz-index: 999;\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 14px;\n\n\t\t\ttext-align: center;\n\n\t\t\tcolor: var(--ion-color-black) !important;\n\n\t\t\tspan {\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 22px;\n\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--ion-color-black) !important;\n\n\t\t\t}\n\t\t}\n\t\t.status-show {\n\t\t\twidth: 85%;\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\tbottom: 110px;\n\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\n\t\t\tbackground: white;\n\t\t\tpadding: 10px 20px;\n\t\t\ttransform: translateX(-50%);\n\t\t\tborder-radius: 3px;\n\t\t\tz-index: 999;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-color-black) !important;\n\t\t\tbox-shadow: 0px 0px 42px 0px #00000012;\n\t\t}\n\t\t&.hide-item {\n\t\t\tmin-height: 400px;\n\t\t\tmax-height: 400px;\n\t\t\topacity: 1;\n\t\t\tz-index: 1;\n\t\t}\n\t}\n}\n\n.header-title {\n\tfont-family: AppFontBold;\n\tfont-size: 22px;\n\n\ttext-align: center;\n\ttext-transform: uppercase;\n\tmargin-bottom: 16px;\n\tcolor: #fff !important;\n}\n\n.estimation-text {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 16px;\n\n\ttext-align: center;\n\tcolor: var(--ion-color-black) !important;\n}\n.estimation-time {\n\tfont-family: AppFontBold;\n\tfont-weight: 700;\n\tfont-size: 22px;\n\tline-height: 24px;\n\n\ttext-align: center;\n\n\tcolor: var(--ion-color-black) !important;\n\tmargin-bottom: 17px;\n}\n\n.delivery-info {\n\twidth: 280px;\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 1.15em;\n\tletter-spacing: 2%;\n\ttext-align: center;\n\tvertical-align: bottom;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-black);\n\tmargin-bottom: 17px;\n}\n\n.delivery-options {\n\tposition: relative;\n\tbackground-color: #fff;\n\tpadding: 20px 15px;\n\tmargin-bottom: 20px;\n}\n\n.map-container {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n}\n\n.map-frame {\n\tborder: 2px solid black;\n\theight: 100%;\n}\n\n#map-item {\n\theight: 100%;\n}\n\n.bigger-img {\n\tmin-width: 200px\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
